<script lang="ts">
  import { range, keys } from 'lodash';
  import { get } from 'svelte/store';
  import { Html, CheckboxInput, NumberInput, TextInput } from '../data/surveys';
  import { createEventDispatcher, onMount } from 'svelte'
  import { gsap } from 'gsap'

  let el: HTMLElement
  let emit = createEventDispatcher<{ submit: { name: string, surname: string, generation: any, is_triamudom: boolean } }>()
  let error_message = {}
  const data = [
    new TextInput(<const>'name', 'ชื่อจริง'),
    new TextInput(<const>'surname', 'นามสกุล'),
    new NumberInput(<const>'generation', 'ต.อ. รุ่น', range(95, 0, -1)),
    new CheckboxInput(
      <const>'is_triamudom',
      'ฉันยืนยันว่าฉันเป็นศิษย์เก่า-ศิษย์ปัจจุบันของโรงเรียนเตรียมอุดมศึกษา'
    ),
  ];

  onMount(() => {
    gsap.from(el, { autoAlpha: 0 })
  })

  async function submit() {
    error_message = {}
    let response: any = {}
    for (const f of data) {
      if ("validator" in f && !f.validator()) {
        error_message[f.field] = "โปรเติมคำในช่องว่าง";
        let unwatch = f.value.subscribe(() => {
          if (f.validator()) {
            error_message[f.field] = "";
            unwatch();
          }
        });
      } else {
        response[f.field] = get(f.value as any)
      }
    }
    if (keys(error_message).length == 0) {
      await gsap.to(el, { autoAlpha: 0 }).then()
      emit('submit', response)
    }
  }
</script>

<section bind:this={el} class="container pt-8 pb-12 px-4 mx-auto" style='max-width: min(500px, 100%)'>
  <h1 class='font-bold text-2xl mt-8'>ร่วมลงรายชื่อ</h1>
  <form
    on:submit|preventDefault={submit}
    style="min-height: 400px"
    class="flex flex-col justify-center"
  >
    {#each data as f}
      {#if f instanceof Html}
        <!-- RENDER MARKDOWN -->
        {@html f.value}
      {:else}
        <!-- DYNAMIC INPUT COMPONENT -->
        <svelte:component this={f.component} {...f} />
        {#if error_message[f.field]}
          <div class="help text-sm text-primary">
            {error_message[f.field]}
          </div>
        {/if}
      {/if}
    {/each}
    <button type="submit" class="button is-primary mt-8">ส่ง</button>
  </form>
</section>
